export const MONTH_COUNT = 2;
export const MONTH_COUNT_MOBILE = 1;
export const MINIMUM_NIGHTS = 1;
export const MAXIMUM_NIGHTS = 30;
export const MAXIMUM_SHOW_DAYS = 365;
